var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import { BsSearch } from "react-icons/bs";
import { Table } from 'template/lib';
import useAuth from "../../hooks/useAuth";
import useTitle from "../../hooks/useTitle";
import api from "../../services/api";
import { CiImport } from "react-icons/ci";
import RelatorioTemplate from '../Interation/RelatorioTemplate';
import { renderToString } from "react-dom/server";
var DetailInteration = function () {
    var id = useParams().id;
    var _a = useAuth(), login = _a.login, handleLogout = _a.handleLogout;
    var setTitle = useTitle().setTitle;
    var history = useHistory();
    var _b = useState([]), helps = _b[0], setHelps = _b[1];
    var _c = useState([]), details = _c[0], setDetails = _c[1];
    var _d = useState(1), page = _d[0], setPage = _d[1];
    var _e = useState(15), pageSize = _e[0], setPageSize = _e[1];
    var _f = useState(false), hasNext = _f[0], setHasNext = _f[1];
    var _g = useState(0), totalPages = _g[0], setTotalPages = _g[1];
    var _h = useState(true), loading = _h[0], setLoading = _h[1];
    var _j = useState(false), alertOpen = _j[0], setAlertOpen = _j[1];
    var config = {
        headers: { Authorization: "Bearer " + (login === null || login === void 0 ? void 0 : login.token) }
    };
    var userRole = login === null || login === void 0 ? void 0 : login.role;
    useEffect(function () {
        if (!helps || helps.length === 0)
            return;
        var hasChanges = false;
        var updatedHelps = helps.map(function (help) {
            var details = help.details || [];
            var allSigned = details.length > 0 && details.every(function (detail) { return detail.workItemSignature === true; });
            // só altera se o valor for diferente do atual
            if (help.workItemSignature !== allSigned) {
                hasChanges = true;
                return __assign(__assign({}, help), { workItemSignature: allSigned });
            }
            return help;
        });
        if (hasChanges) {
            setHelps(updatedHelps);
        }
    }, [helps]);
    var filter = function (id) {
        if (id !== null && Array.isArray(helps)) {
            // Marca todos como false, e só o selecionado como true
            var updatedHelps = helps.map(function (item) { return (__assign(__assign({}, item), { viewed: !(item.id === id) })); });
            // Encontra o item selecionado atualizado
            var selectedItem = updatedHelps.find(function (item) { return item.id === id; });
            if (!selectedItem)
                return;
            // Garante que os detalhes estão atualizados
            var updatedDetails = selectedItem.details.map(function (detail) { return (__assign({}, detail)); });
            // Atualiza os estados
            setHelps(updatedHelps);
            setDetails(updatedDetails);
        }
    };
    var imprimir = function (id) { return __awaiter(void 0, void 0, void 0, function () {
        var pdfResponse, relatorioHTML, html, iframe, conteudo, doc;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, api.get("/signature/pdf/" + id, config)];
                case 1:
                    pdfResponse = _b.sent();
                    relatorioHTML = _jsx(RelatorioTemplate, __assign({}, pdfResponse.data), void 0);
                    html = renderToString(relatorioHTML);
                    iframe = document.createElement("iframe");
                    iframe.style.position = "fixed";
                    iframe.style.right = "0";
                    iframe.style.bottom = "0";
                    iframe.style.width = "0";
                    iframe.style.height = "0";
                    iframe.style.border = "none";
                    iframe.setAttribute("aria-hidden", "true");
                    document.body.appendChild(iframe);
                    conteudo = "\n          <html>\n            <body>" + html + "</body>\n          </html>\n        ";
                    doc = iframe.contentDocument || ((_a = iframe.contentWindow) === null || _a === void 0 ? void 0 : _a.document);
                    if (!doc) {
                        console.error("Não foi possível acessar o documento do iframe.");
                        return [2 /*return*/];
                    }
                    doc.open();
                    doc.write(conteudo);
                    doc.close();
                    // Aguarda o conteúdo ser renderizado e imprime
                    setTimeout(function () {
                        var win = iframe.contentWindow;
                        if (win) {
                            win.focus();
                            win.print();
                        }
                        setTimeout(function () { return iframe.remove(); }, 1000);
                    }, 500);
                    return [2 /*return*/];
            }
        });
    }); };
    // 2. Inicialize o array
    var lineBtnsWithoutAssginTo = [];
    if (userRole === "Customer" || userRole === "CustomerAdmin") {
        lineBtnsWithoutAssginTo.push({
            name: "Detalhes",
            icon: _jsx(BsSearch, {}, void 0),
            fn: function (id) { return filter(id); },
        });
    }
    else {
        lineBtnsWithoutAssginTo.push({
            name: "Detalhes",
            icon: _jsx(BsSearch, {}, void 0),
            fn: function (id) { return filter(id); },
        });
    }
    var lineBtnsWithoutAssgin = [];
    if (userRole === "Customer" || userRole === "CustomerAdmin") {
        lineBtnsWithoutAssgin.push({
            name: "Imprimir",
            icon: _jsx(CiImport, {}, void 0),
            fn: function (id) { return imprimir(id); },
        });
    }
    else {
        lineBtnsWithoutAssgin.push({
            name: "Imprimir",
            icon: _jsx(CiImport, {}, void 0),
            fn: function (id) { return imprimir(id); },
        });
    }
    useEffect(function () {
        if (!id || !login)
            return;
        setTitle('Interações');
        api.get("/companies/iteration/" + id + "?page=" + page + "&pagesize=" + pageSize, config)
            .then(function (response) {
            var items = response.data.items;
            // Atualiza o estado do array de ajuda completo
            setHelps(items);
            // Paginação
            var totalPages = Math.ceil(response.data.totalCount / pageSize);
            setTotalPages(totalPages);
            setHasNext(totalPages > page);
        })
            .catch(function (err) {
            var _a;
            if (((_a = err.response) === null || _a === void 0 ? void 0 : _a.status) === 401) {
                handleLogout();
                history.push('/');
            }
        })
            .finally(function () { return setLoading(false); });
    }, [id, login, page, pageSize]);
    useEffect(function () {
        setInterval(function () {
            setAlertOpen(false);
        }, 15000);
    }, [alertOpen]);
    return (_jsx(_Fragment, { children: _jsx("div", __assign({ className: 'pb-20 h-screen ' }, { children: _jsxs("div", __assign({ className: 'overflow-auto h-full' }, { children: [_jsx(Table, { loading: loading, data: helps, size: pageSize, hasNext: hasNext, page: page, setPage: setPage, lineButton: lineBtnsWithoutAssginTo, title: 'Intera\u00E7\u00F5es', setSize: setPageSize, totalPAges: totalPages, columns: [
                            { label: 'ID', key: 'id', eventClick: lineBtnsWithoutAssginTo[0].fn },
                            { label: 'Cliente', key: 'clientName', maxLenghtToShowSeeMore: 90 },
                            { label: 'Título', key: 'title', maxLenghtToShowSeeMore: 180 },
                            { label: 'Status', key: 'status' },
                            { label: 'Data Início', key: 'startDate' },
                            { label: 'Data Fim', key: 'finishDate' }
                        ] }, void 0), _jsx(Table, { loading: loading, page: page, setPage: setPage, data: details, totalPAges: totalPages, title: 'Tarefas da Intera\u00E7\u00E3o', lineButton: lineBtnsWithoutAssgin, columns: [
                            { label: 'Id', key: 'id', eventClick: lineBtnsWithoutAssginTo[0].fn },
                            { label: 'Data Limite', key: 'dataLimit' },
                            { label: 'Titulo', key: 'title', maxLenghtToShowSeeMore: 180 },
                            { label: 'Status', key: 'status' },
                            { label: 'Horas Previstas', key: 'estimatedHours' },
                            { label: 'Horas Realizadas', key: 'workedHours' },
                            { label: 'Data Finalização', key: 'finishDateFormatted' },
                            { label: 'Descrição', key: 'workComments' },
                            { label: 'Usuarios', key: 'userNames' },
                        ] }, void 0)] }), void 0) }), void 0) }, void 0));
};
export default DetailInteration;
